import { render, staticRenderFns } from "./ColorPicker.vue?vue&type=template&id=c1a46d8c&scoped=true"
import script from "./ColorPicker.vue?vue&type=script&setup=true&lang=js"
export * from "./ColorPicker.vue?vue&type=script&setup=true&lang=js"
import style0 from "./ColorPicker.vue?vue&type=style&index=0&id=c1a46d8c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c1a46d8c",
  null
  
)

export default component.exports